
class VideoPanel extends HTMLElement{
    constructor() {
        super();
    }

    connectedCallback() {
        /** @type {HTMLButtonElement | null} */
        this.video_control = this.querySelector(".video-control");
        /** @type {HTMLButtonElement | null} */
        this.video_speaker = this.querySelector(".video-speaker");
        /** @type {HTMLVideoElement | null} */
        this.video = this.querySelector('video');

        if (this.dataset.initialized) return;
        this.dataset.initialized = 'true';

        this.video_control?.addEventListener('click', ()=>{
            this.videoAction();
        })
        this.video_speaker?.addEventListener('click', () => {
            this.videoSpeak();
        })

        if (this.video?.readyState >= 2) {
            this.#markVideoReady();
        } else {
            this.video?.addEventListener('loadeddata', () => this.#markVideoReady(), { once: true });
            this.video?.addEventListener('playing', () => this.#markVideoReady(), { once: true });
        }
    }

    async videoAction () {
        const video = this.video;
        if (!video) return;

        if (video.paused) {
            await window.HiNoteLazyVideo?.load?.(video);
            const playPromise = video.play();
            if (playPromise instanceof Promise) {
                playPromise.catch(() => {});
            }
            this.video_control?.setAttribute("isplaying", "");
            this.#updateControlLabel(true);
        } else {
            video.pause();
            this.video_control?.removeAttribute("isplaying");
            this.#updateControlLabel(false);
        }
    }

    videoSpeak () {
        const video = this.video;
        if (!video) return;

        if (video.muted) {
            video.muted = false;
            this.video_speaker?.removeAttribute("muted");
            this.#updateSpeakerLabel(false);
        } else {
            video.muted = true;
            this.video_speaker?.setAttribute("muted", "");
            this.#updateSpeakerLabel(true);
        }
    }

    /** @param {boolean} isPlaying */
    #updateControlLabel (isPlaying) {
        if (!this.video_control) return;
        const label = isPlaying
            ? this.video_control.dataset.labelPause
            : this.video_control.dataset.labelPlay;
        if (label) this.video_control.setAttribute('aria-label', label);
    }

    /** @param {boolean} isMuted */
    #updateSpeakerLabel (isMuted) {
        if (!this.video_speaker) return;
        const label = isMuted
            ? this.video_speaker.dataset.labelUnmute
            : this.video_speaker.dataset.labelMute;
        if (label) this.video_speaker.setAttribute('aria-label', label);
    }

    #markVideoReady () {
        this.dataset.videoReady = 'true';
    }
}

if (!customElements.get('video-panel')) {
  customElements.define('video-panel', VideoPanel);
}
